
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/similar",
      function () {
        return require("private-next-pages/similar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/similar"])
      });
    }
  